import { useTranslation } from 'react-i18next'

import { clsx } from 'clsx'

import { MyOrderStatusInfo } from 'entities/common/my-ticket/components/my-order-status-info'
import type { MyOrderCardProps } from 'entities/common/my-ticket/model/types'

import SimpleImage from 'shared/images/empty-image.webp'
import { priceShow } from 'shared/lib/priceShow.ts'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types.ts'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

export const MyOrderCard = ({
  icon,
  title,
  price,
  status,
  details,
  imageSrc,
  onClick,
  onStatusClick,
}: MyOrderCardProps) => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      <div
        className={clsx(s.top, onClick && s.clickable)}
        onClick={onClick}
      >
        {icon && (
          <AppIcon
            id={icon}
            width={40}
            height={40}
            className={s.icon}
          />
        )}

        {imageSrc && (
          <ImageLazy
            src={imageSrc}
            className={s.image}
          />
        )}

        {!icon && !imageSrc && (
          <ImageLazy
            src={SimpleImage}
            className={s.image}
          />
        )}

        <div className={s.box}>
          <div className={s.info}>
            {title && <p className={clsx('semi-bold-16', s.title)}>{title}</p>}

            {details && (
              <p className={clsx('regular-13', s.subtitle)}>{details}</p>
            )}
          </div>

          <AppIcon id={AllIcons.ARROW_RIGHT_BOLD} />
        </div>
      </div>

      <div className={s.bot}>
        {price && (
          <p className={clsx('bold-16', s.price)}>
            {t('price_som', { price: priceShow(price) })}
          </p>
        )}

        {status && (
          <MyOrderStatusInfo
            statusInfo={status?.info}
            color={status?.config?.color}
            title={t(status?.config?.name!)}
            background={status?.config?.background}
            onClick={onStatusClick}
          />
        )}
      </div>
    </div>
  )
}
